export const discountSectionTestIds = {
  toggle: 'discount-panel-toggle',
  amount: 'discount-panel-amount',
  typePercentage: 'discount-panel-type-percentage',
  typeFixed: 'discount-panel-type-fixed',
};
